module.exports = __webpack_public_path__ + "img/marius.3e20c0e3.png";